import { CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const CUSTOMER_MANAGEMENT_CUSTOMER_GET_CUSTOMER_SUFFIX = "/get";
/** /customer/get */
export const CUSTOMER_MANAGEMENT_CUSTOMER_GET_CUSTOMER_PATH = `${
  CUSTOMER_MANAGEMENT_CUSTOMER_CONTROLLER_ROOT_PATH
}${
  CUSTOMER_MANAGEMENT_CUSTOMER_GET_CUSTOMER_SUFFIX
}`;
